import mobile from 'is-mobile';

const scrollToElem = el => {
    window.scrollTo({
        top: el.offsetTop - (mobile() ? 80 : 118),
        behavior: 'smooth',
    });
};

export default scrollToElem;
